import { mapActions, mapState, mapGetters } from 'vuex';
export default {
  data() {
    return {
      flags: null,
      fieldConditions: [],
    };
  },
  mounted() {},

  computed: {
    ...mapGetters('impersonate', ['viewbarEnabled', 'impersonating']),
    ...mapGetters('orders', ['isQuote']),
    ...mapState('orders/dealer', ['dealer']),
    ...mapState('orders', ['message']),
  },
  methods: {
    ...mapActions('impersonate', [
      'isImpersonating',
      'getViewbarStatus',
      'enableViewBar',
      'setImpersonatingAs',
    ]),
    ...mapActions('layout', ['updateLayoutFields', 'getLayoutFields']),
    ...mapActions('orders', ['setMessage']),
  },
};
